import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["choice", "strikeButton", "strikeInput", "submitButton"];

  connect() {
    this.strikeInputTargets.forEach((input) => {
      this.applyStrike(input.value, input.checked);
    });
    this.updateSubmitState();
  }

  updateSubmitState() {
    if (!this.hasSubmitButtonTarget) return;

    const answer = this.element.querySelector(
      'input[name$="[answer_index]"]:checked',
    );
    const certainty = this.element.querySelector(
      'input[name$="[confidence]"]:checked',
    );
    this.submitButtonTarget.disabled = !(answer && certainty);
  }

  toggleStrike(event) {
    event.preventDefault();
    const index = event.currentTarget.dataset.index;
    const input = this.inputFor(index);
    if (!input) return;

    input.checked = !input.checked;
    this.applyStrike(index, input.checked);
  }

  applyStrike(index, struck) {
    const choice = this.choiceTargets.find(
      (el) => el.dataset.index === String(index),
    );
    const button = this.strikeButtonTargets.find(
      (el) => el.dataset.index === String(index),
    );

    choice?.classList.toggle("line-through", struck);
    button?.setAttribute("aria-pressed", struck ? "true" : "false");
  }

  inputFor(index) {
    return this.strikeInputTargets.find((el) => el.value === String(index));
  }
}
